import { useCallback, useRef } from "react";
import { useNavigate } from "react-router";
import { useApi } from "../../hooks/useApi";
import type { OnboardingListRow } from "../../types/onboarding";

export const toOpenOnboardingsUrl = (companyId: number) => `/api/onboardings?status=open&companyId=${companyId}`;

// For a page about one onboarding when the header picks another company: open that company's onboarding in
// progress, else the dashboard filtered to it (or unfiltered for All Companies).
export function useOpenCompanyOnboarding() {
  const navigate = useNavigate();
  const { get } = useApi();
  const latest = useRef<number | null>(null);
  return useCallback(async (companyId: number | null) => {
    latest.current = companyId;
    if (companyId === null) return navigate("/onboarding");
    const rows = await get<OnboardingListRow[]>(toOpenOnboardingsUrl(companyId)).catch(() => []);
    if (latest.current !== companyId) return;
    const row = rows[0];
    navigate(row ? `/onboarding/${row.onboardingId}?companyId=${companyId}` : `/onboarding?companyId=${companyId}`);
  }, [get, navigate]);
}
